(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportservice2/assets/javascripts/sportradar-iframe.js') >= 0) return;  svs.modules.push('/modules/sportservice2/assets/javascripts/sportradar-iframe.js');

'use strict';

const {
  useMemo
} = React;
const {
  useLocation
} = ReactRouterDOM;
const {
  baseUrl
} = svs.core.data;
const Icon = svs.ui.ReactIcon;
const FallbackView = () => React.createElement("div", {
  className: "f-center fallback-view"
}, React.createElement(Icon, {
  color: "fc-red",
  icon: "rest",
  size: "1000"
}), React.createElement("p", {
  className: "fc-navy f-800 fallback-view-text"
}, "H\xE4r \xE4r det tomt!"));
const SportRadarIframe = () => {
  const location = useLocation();
  const url = useMemo(() => {
    if (location.pathname === "".concat(baseUrl, "/sport")) {
      return 'https://s5.sir.sportradar.com/svenskaspel2/sv';
    } else if (location.pathname === "".concat(baseUrl)) {
      return 'https://ls.sir.sportradar.com/svenskaspel/sv';
    }
  }, [location]);
  return React.createElement("div", {
    className: "sportservice-iframe align-center"
  }, url && React.createElement("div", {
    className: "iframe-wrapper",
    id: "sr-iframe-wrapper"
  }, React.createElement("iframe", {
    className: "iframe",
    id: "sr-iframe",
    scrolling: "no",
    src: url
  }, React.createElement(FallbackView, null))));
};
setGlobal('svs.sportservice2.SportRadarIframe', SportRadarIframe);

 })(window);